import axios from 'axios'

export default function setupInterceptor() {
  const that = this;
  axios.interceptors.response.use(response => response, function(error) {
    if (error && error.response) {
      const statusCode = error.response.status;
      const statusText = error.response.statusText;

      let errorDetails = 'No error details';
      if(error.response.data && error.response.data.message){
        errorDetails = error.response.data.message.message ? error.response.data.message.message: error.response.data.message;
      }

      const errorMessage = 'A system error has occurred, please try again in 24 hours.'+
      ' If the error persists, copy the "Error Details" below,'+
      ' then click "Report Error" and submit a ticket with the details.';
      const errorHtml = `<b>Error:${statusCode} ${statusText}</b> </br> ${errorMessage}`;

      that.prototype.$toast.error(errorHtml, errorDetails);
    }
  });
}
